(function (Controller, Helper, Config, Model, Service, Handler, Analytics, LocalStorage, $) {
    'use strict';

    Controller.checkStorageSession = function () {
        // Chequeo el tiempo de vida del storage, si expira lo re-inicializo.
        if (LocalStorage.checkExpiration(Config.LoginFlagKey) == null) {
            LocalStorage.setExpiredItem(Config.LoginFlagKey, false);
        }

        if (LocalStorage.getItem(Config.LoginFlagKey).value) {
            Helper.showPreloader();
            Controller.activateSessionPull();
            return true;
        } else {
            LocalStorage.setExpiredItem(Config.LoginFlagKey, true);
        }

        return false;
    }

    Controller.activateSessionPull = function () {
        if (Model.Window.modo == 'D') {
            setInterval(function () {
                if (LocalStorage.checkExpiration(Config.LoginFlagKey) == null) {
                    LocalStorage.setExpiredItem(Config.LoginFlagKey, false);
                    Helper.hidePreloader();
                }

                Service.isLogged();
            }, Config.returnBackInterval);
        }
    }

})(LN.Controller, LN.Helper, LN.Config, LN.Model, LN.Service, LN.Handler, LN.Analytics, LN.LocalStorage, jQuery);


// WEBPACK FOOTER //
// ./Statics/scripts/login/controllers/redes.js